/*
    EG Megamenu Image
    © 2022 EcomGraduates
    https://wwww.ecomgraduates.com
*/


document.querySelectorAll('.mega-menu__link').forEach(elem => {
    if (elem.textContent.includes('|')) {
        const title = elem.textContent.split('|')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const img = elem.textContent.split('|')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const sub = elem.textContent.split('|')[2].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        elem.innerHTML = `
        <div class="rcrmegamenu">
        <tr>
        <th>
            <img
                src="${img}"
                alt=""
                width=""
                height=""
                style="max-width: 25%; height: auto; margin-bottom: .4rem; padding-right: 1rem;">
                </th>
                <th>
              <div>
                ${title}<br>
            <img src="https://cdn.shopify.com/s/files/1/0078/3148/6537/files/Learn-More.png?v=1715621193"
            style="width: 45%; margin-top: .4rem; padding-right: 1rem;>
            </div>
</th>
</tr>
</div>
<div style="text-align: center"><i>
                ${sub}
            </i></div>
        `
        elem.closest('.mega-menu__list').style.gridTemplateColumns = 'repeat(3, minmax(0, 1fr))'
    }
})

document.querySelectorAll('.menu-drawer__menu-item').forEach(elem => {
    if (elem.textContent.includes('|')) {
        const title = elem.textContent.split('|')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const img = elem.textContent.split('|')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const sub = elem.textContent.split('|')[2].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        elem.innerHTML = `
        <div class="rcrmegamenu">
        <tr>
        <th>
            <img
                src="${img}"
                alt=""
                width=""
                height=""
                style="max-width: 25%; height: auto; margin-bottom: .4rem; padding-right: 1rem;">
                </th>
                <th>
              <div>
                ${title}<br>
            <img src="https://cdn.shopify.com/s/files/1/0078/3148/6537/files/Learn-More.png?v=1715621193"
            style="width: 45%; margin-top: .4rem; padding-right: 1rem;>
            </div>
</th>
</tr>
</div>
<div style="text-align: center"><i>
                ${sub}
            </i></div>
        `
    }
})
